import { render, staticRenderFns } from "./r-currency-deprecate-mode.vue?vue&type=template&id=5211ad46"
import script from "./r-currency-deprecate-mode.vue?vue&type=script&lang=js"
export * from "./r-currency-deprecate-mode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5211ad46')) {
      api.createRecord('5211ad46', component.options)
    } else {
      api.reload('5211ad46', component.options)
    }
    module.hot.accept("./r-currency-deprecate-mode.vue?vue&type=template&id=5211ad46", function () {
      api.rerender('5211ad46', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/currency/r-currency-deprecate-mode.vue"
export default component.exports